import * as React from 'react';
import * as IdentityHelper from './api/identity/identityHelper';
import route, { RouteProvider } from './route/Index';
import { IUser } from './shared/iUser';
import { ENodeEnv, EReduxState } from './store/enum';
import { useAppDispatch, useAppSelector } from './store/hook';
import { selectUser, setUser } from './store/user/userSlice';
import { CircularProgress } from '@mui/material';

interface IAppProps {}

const App = (props: IAppProps) => {
    const dispatch = useAppDispatch();
    const user = useAppSelector(selectUser);

    const fetchUser = async () => {
        let user: IUser;
        if (process.env.NODE_ENV == ENodeEnv.Production) user = await IdentityHelper.getUserAsync();
        else user = { email: 'test@gmail.com', first_Name: 'Mario', last_Name: 'Rossi', isAdmin: true };
        dispatch(setUser(user));
    };

    React.useEffect(() => {
        fetchUser();
    }, []);

    return user.status == EReduxState.fulfilled ? <RouteProvider router={route} /> : <CircularProgress style={{ position: 'absolute', top: '50%', left: '47%' }} />;
};

export default App;
